import {ShortLocaleNameEnum} from '../../locale/locale-context-type';

// Публичные токены окружений Usertour.js (встраиваются в клиентский бандл, не секрет).
const USERTOUR_TOKEN_PRODUCTION = 'cmqfary7p000c2uumu54ama4p';
const USERTOUR_TOKEN_STAGING = 'cmqggsyrx00bj2uumrbpmjg7k';

// Прод-сборка использует прод-токен, остальные окружения (staging, preproduction,
// локальная разработка) — стейджинговый. Можно переопределить через env USERTOUR_TOKEN.
const usertourToken =
    process.env.USERTOUR_TOKEN ||
    (process.env.ENVIRONMENT === 'production' ? USERTOUR_TOKEN_PRODUCTION : USERTOUR_TOKEN_STAGING);

export const usertourSettings = {
    token: usertourToken,
    scriptId: 'usertourScript',
    envVars: {
        WS_URI: 'https://usertour.rocketdata.io/',
        ASSETS_URI: 'https://usertour.rocketdata.io/sdk/',
        USERTOURJS_ES2020_URL: 'https://usertour.rocketdata.io/sdk/es2020/usertour.js',
        USERTOURJS_LEGACY_URL: 'https://usertour.rocketdata.io/sdk/legacy/usertour.iife.js',
    },
};

export const initialChatMessage: Record<ShortLocaleNameEnum.en | ShortLocaleNameEnum.ru, string> = {
    [ShortLocaleNameEnum.ru]: 'Добрый день! \nОставьте ваш вопрос, и наш специалист ответит в ближайшее время.',
    [ShortLocaleNameEnum.en]:
        'Hello! \nPlease leave your message, and our specialists will get back to you as soon as possible.',
};

export const helpDeskChatSettings = {
    url: '//cdn5.helpdeskeddy.com//js/modules/chat_widget/hde.js',
    host: 'roketdata.helpdeskeddy.com',
    id: 'hde-chat-widget',
    position: 'bottom-right',
    buttonId: 'hde-button',
};
